export class Link {
  constructor(public name: string, public address: string) {
    
  }
}
